import { findIndex } from 'lodash';
import {
  getStaffAction,
  updateStaffAction,
  getStaffSuggestionsAction,
  addStaffAction,
  deleteStaffAction,
} from './actions';
import { listReducer, namedListParams } from '../../utils/crudUtils';

export const key = 'EditStaff';

export const initialState = {
  staff: namedListParams('staff'),
  staffSuggestions: namedListParams('staffSuggestions'),
  staffUpdating: false,
};

const editStaffReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getStaffAction.FAILURE:
    case getStaffAction.TRIGGER:
    case getStaffAction.SUCCESS:
      return listReducer(state, type, payload, initialState.staff.listName);

    case updateStaffAction.SUCCESS: {
      const staff = [...(state?.staff?.data || [])];
      const updatedStaffIndex = findIndex(state?.staff?.data || [], { id: payload?.entity?.id });
      staff.splice(updatedStaffIndex, 1, payload?.entity);
      return { ...state, staff: { ...state.staff, data: staff } };
    }

    case addStaffAction.SUCCESS: {
      return {
        ...state,
        [initialState.staff.listName]: {
          ...state[initialState.staff.listName],
          data: [payload.entity, ...state.staff.data],
        },
      };
    }

    case getStaffSuggestionsAction.TRIGGER:
    case getStaffSuggestionsAction.SUCCESS:
    case getStaffSuggestionsAction.FAILURE:
      return listReducer(state, type, payload, initialState.staffSuggestions.listName);

    case deleteStaffAction.TRIGGER:
      return { ...state, staffUpdating: true };
    case deleteStaffAction.SUCCESS: {
      return {
        ...state,
        [initialState.staff.listName]: {
          ...state.staff,
          data: state[initialState.staff.listName]?.data.filter(d => d?.id !== payload?.id),
        },
        staffUpdating: false,
      };
    }
    case deleteStaffAction.FAILURE:
      return { ...state, staffUpdating: false };

    default:
      return state;
  }
};

export default editStaffReducer;
